 
 
 
 
 
 
define(['model/objectModel'], function(ObjectModel) {
    'use strict';
    var SIMPLE_PROPERTIES = [
        'country',
        'countryCode',
        'countryCodeISO3',
        'countrySecondarySubdivision',
        'countryTertiarySubdivision',
        'countrySubdivision',
        'countrySubdivisionName',
        'freeformAddress',
        'municipality',
        'municipalitySubdivision',
        'postalCode',
        'extendedPostalCode',
        'streetName',
        'streetNumber'
    ];

    var AddressModel = function(json) {
        SIMPLE_PROPERTIES.forEach(function(property) {
            if (typeof json[property] !== 'undefined') {
                this[property] = json[property];
            }
        }, this);
        return this;
    };
    AddressModel.prototype = Object.create(ObjectModel.prototype);
    AddressModel.prototype.constructor = AddressModel;

    return AddressModel;
});



// WEBPACK FOOTER //
// ./model/search/addressModel.js